<div class="ui-accounts-admin-new">
  <h3 class="ui-accounts-admin-new-title ui-title" mat-dialog-title>Administrar cuenta</h3>
  
  <div class="ui-accounts-admin-new-content" mat-dialog-content>
    <div class="ui-form">
      <ui-autocomplete 
        [data]="adminAccountsDataFiltered | async"
        [display]="adminAccountsDataDisplay.bind(this)"
        [loading]="adminAccountsLoading"
        value="number"
        name="name"
        placeholder="Número de cliente, DNI, Teléfono o Email"
        (onChange)="adminAccounts.next($event)"
      ></ui-autocomplete>
    </div>
  </div>
    
  <div class="ui-accounts-admin-new-actions" mat-dialog-actions>
    <button class="ui-button" mat-button (click)="onCancel()">Cancelar</button>
    <button class="ui-button" mat-button (click)="onAccountSelect()" [disabled]="adminAccountsValue <= 0" color="primary">Cambiar de cuenta</button>
  </div>
</div>